import { useLoginAndProfileService } from '@/app/context/DIContext/DIServices'
import { Profile } from '@/shared/store/useAppStore'

const useLoginAndProfileRepository = () => {
    const {
        fetchProfiles,
        checkPin,
        setProfile,
        deleteProfile,
        updateProfile,
    } = useLoginAndProfileService()

    const fetchUserProfiles = () => fetchProfiles()
    const checkParentControlPin = (pin: number, id: string) => checkPin(pin, id)
    const postUserProfile = (profile: {
        version: number
        profile_name: string
        isKid: boolean
        order: string
        iconId: string
    }) => setProfile(profile)
    const deleteUserProfile = (id: string) => deleteProfile(id)
    const updateUserProfile = (profile: Profile) => updateProfile(profile)
    return {
        fetchUserProfiles,
        checkParentControlPin,
        postUserProfile,
        deleteUserProfile,
        updateUserProfile,
    }
}

export { useLoginAndProfileRepository }
